import React,{Component} from 'react';
import {variables} from '../Variables.js';
import MyPage from "../../src/MyPage";
import SubTabsGeneralParams from "../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../helpers/user.js";
import axiosService from '../helpers/axios';


import useSWR from "swr";
import { fetcher } from "../helpers/axios";
import { getUser } from "../hooks/user.actions";


  export default class UserProfile extends Component{ 

   
constructor(props){
  super(props);

  this.state={
      users:[],
      modalTitle:"",
      modalTitlePassword:"",
      id:0,
      username:"",
      first_name:"",
      last_name:"",
      email:"",
      is_active:false,
      is_superuser:false,
      password:"",
      password2:"",
      passwordError: false,
      passwordsMatch: false,
      
      FirstNameFilter:"",
      LastNameFilter:"",
      usersWithoutFilter:[],
      user: null,
      useremailExists: false,
      usernameExists: false,
      userNames :[],
      userEmails:[],
      isEditMode: false,
      isEditPasswordMode: false,
      
      
  }
}


  FilterFn(){
    var FirstNameFilter=this.state.FirstNameFilter;
    var LastNameFilter = this.state.LastNameFilter;
  
    var filteredData=this.state.usersWithoutFilter.filter(
        function(el){
            return el.first_name.toString().toLowerCase().includes(
                FirstNameFilter.toString().trim().toLowerCase()
            )&&
            el.last_name.toString().toLowerCase().includes(
                LastNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({users:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.usersWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({users:sortedData});

}

changeFirstNameFilter = (e)=>{
  this.state.FirstNameFilter=e.target.value;
  this.FilterFn();
}
changeLastNameFilter = (e)=>{
  this.state.LastNameFilter=e.target.value;
  this.FilterFn();
}


refreshList() {
  axiosService.get('/userlist/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      console.log(data); // Add this line for debugging
      this.setState({ users: data, usersWithoutFilter: data });
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
}

fetchUserNames() {
  axiosService.get('/userlist/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const userNames = data.map(item => item.username);
      this.setState({ userNames: userNames });
    })
    .catch(error => {
      console.error("Error fetching user names:", error);
    });
}

fetchUserEmails() {
  axiosService.get('/userlist/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const userEmails = data.map(item => item.email);
      this.setState({ userEmails: userEmails });
    })
    .catch(error => {
      console.error("Error fetching user emails:", error);
    });
}

checkUserNameExists = (event) => {
  const enteredUsername = event.target.value.toLowerCase(); // Convert to lowercase
  const { userNames } = this.state;
  const usernameExists = userNames.some((user) => user.toLowerCase() === enteredUsername);
  this.setState({ usernameExists });
};

checkUserEmailExists = (event) => {
  const enteredUseremail = event.target.value.toLowerCase(); // Convert to lowercase
  const { userEmails } = this.state;
  const useremailExists = userEmails.some((user) => user.toLowerCase() === enteredUseremail);
  this.setState({ useremailExists });
};

  // Function to toggle edit mode
  toggleEditMode = () => {
    this.setState((prevState) => ({ isEditMode: !prevState.isEditMode }));
  };

// Function to toggle edit mode
toggleEditPasswordMode = () => {
    this.setState((prevState) => ({ isEditPasswordMode: !prevState.isEditPasswordMode }));
  };


  handlePasswordBlur = () => {
    const { password } = this.state;
  
    // Define your password strength criteria
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasDigits = /\d/.test(password);
    const hasSpecialChars = /[!@#$%^&*]/.test(password);
  
    // Check if the password meets the criteria
    const isStrongPassword =
      password.length >= minLength &&
      hasUpperCase &&
      hasLowerCase &&
      hasDigits &&
      hasSpecialChars;
  
    // Set the password error state based on the result
    this.setState({ passwordError: !isStrongPassword });
  };

  handlePassword2Blur = () => {
    const { password, password2 } = this.state;
    const isPasswordsMatch = password === password2; 
    this.setState({ passwordsMatch: !isPasswordsMatch });
  };
  

componentDidMount(){

      this.refreshList();
      this.fetchUserNames();
      this.fetchUserEmails();
    
  
}

changeUserName =(e)=>{
  this.setState({username:e.target.value});
}

changeFirstName =(e)=>{
  this.setState({first_name:e.target.value});
}


changeLastName =(e)=>{
  this.setState({last_name:e.target.value});
}

changeEmail =(e)=>{
  this.setState({email:e.target.value});
}

changePassword =(e)=>{
  this.setState({password:e.target.value});
}

changePassword2 =(e)=>{
  this.setState({password2:e.target.value});
}

changeIsActive = (event) => {
  const isChecked = event.target.checked;
  this.setState({ is_active: isChecked });
};

changeIsSuperuser = (event) => {
  const isChecked = event.target.checked;
  this.setState({ is_superuser: isChecked });
};


addClick(){
  this.setState({
      modalTitle:"Add User",
      id:0,
      username: "",
      first_name: "",
      last_name:"",
      email:"",
      password:"",
      is_active:false,
      is_superuser:false,
      usernameExists: false,
      useremailExists: false,
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit User",
      id:dep.id,
      username:dep.username,
      first_name:dep.first_name,
      last_name:dep.last_name,
      email:dep.email,
      password:dep.password,
      is_active: dep.is_active,
      is_superuser: dep.is_superuser,
      initialUsername: dep.username,
      initialFirst_name: dep.first_name,
      initialLast_name: dep.last_name,
      initialEmail: dep.email,
      initialIsActive: dep.is_active,
      initialIsSuperuser: dep.is_superuser,
      initialPassword:dep.password,
      usernameExists:false,
      useremailExists:false,


  });
}

editClickPassword(dep){
  this.setState({
      modalTitlePassword:"Edit User Password",
      id:dep.id,
      password:"",
      password2:"",


  });
}



createClick() {
  const {username, first_name, last_name, email, is_active, is_superuser,password, userNames, userEmails } = this.state;

  if (!username) {
    alert('User Name is required');
    return;
  }

  if (userNames.some(name => name.toLowerCase() === username.toLowerCase())) {
    alert('Username already exists. Please provide a unique User Name.');
    return;
  }

  if (!first_name) {
    alert('First name is required');
    return;
  }

  if (!email) {
    alert('Email is required');
    return;
  }


  if (userEmails.some(name => name.toLowerCase() === email.toLowerCase())) {
    alert('Email already exists. Please provide a unique email.');
    return;
  }



  axiosService.post('/auth/register/', {
      username: username,
      first_name: first_name,
      last_name:last_name,
      email:email,
      password:password,
      is_active:is_active,
      is_superuser:is_superuser
    })
    .then(result => {
      alert('User created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert(error?.response?.data?.error || error?.message || 'Failed');
    });
}

updateClick(id) {

  const { username,
    first_name,
    last_name,
    email,
    initialUsername,
    initialFirst_name,
    initialLast_name,
    initialEmail,
    userNames, 
    userEmails
    } = this.state;

   // Check if any changes are detected
   if (
    username === initialUsername &&
    first_name === initialFirst_name &&
    last_name === initialLast_name  &&
    email === initialEmail
  ) {
    alert('No changes detected');
    return;
  }

  if (!username) {
    alert('User Name is required');
    return;
  }

  if (userNames.some(name => name.toLowerCase() === username.toLowerCase() && username !== initialUsername)) {
    alert('Username already exists. Please provide a unique User Name.');
    return;
  }

  if (!first_name) {
    alert('First Name is required');
    return;
  }

  if (!last_name) {
    alert('First Name is required');
    return;
  }

  if (!email) {
    alert('Email is required');
    return;
  }

  if (userEmails.some(name => name.toLowerCase() === email.toLowerCase() && email !== initialEmail)) {
    alert('Email already exists. Please provide a unique email.');
    return;
  }

  axiosService.patch('/userlist/' + id + '/', {
      id: this.state.id,
      username:this.state.username,
      first_name: this.state.first_name,
      last_name:this.state.last_name,
      email:this.state.email
    })
    .then((result) => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch((error) => {
      alert(error?.response?.data?.error || error?.message || 'Failed');
    });
}


updateClickPassword(id) {

  const { 
    password,
    password2
    } = this.state;

    if (!password) {
      alert('Password cannot be empty');
      return;
    }

    if (!password2) {
      alert('Retype the Password');
      return;
    }

    if (password !== password2) {
      alert('Passwords do not match');
      return;
    }

  axiosService.patch('/userlist/' + id + '/', {
      id: this.state.id,
      password:this.state.password
    })
    .then((result) => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch((error) => {
      alert(error?.response?.data?.error || error?.message || 'Failed');
    });
}


deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/userlist/' + id + '/')
      .then(() => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      users,
      modalTitle,
      modalTitlePassword,
      id,
      username,
      first_name,
      last_name,
      email,
      password,
      password2,
      passwordError,
      passwordsMatch,
      is_active,
      is_superuser,
      useremailExists,
      usernameExists,
      user,
      isEditMode,
      isEditPasswordMode,
      userList = user ? [user] : [],
      matchingUser = users.find(user => users.email === userList.email),
      matchingUserList = matchingUser ? [matchingUser] : []
  }=this.state;

  // Transform user object into an array
  //const userList = user ? [user] : [];
  // Use the find method to search for a user with a matching id
  //const matchingUser = users.find(user => users.email === userList.email);

// Convert matchingUser to a list (array)
//const matchingUserList = matchingUser ? [matchingUser] : [];
  return(

<div className="App container scrollable-container">

<MyPage />

<div >
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr>

<th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row">
      </div>
      UserID
  </th>

<th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row">
      </div>
      UserName
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
    
      <div className="d-flex flex-row">
      

      </div>
      First Name
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row">
 
      </div>
      Last Name
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row">
      </div>
      Email
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row">
      </div>
      Edit Profile
  </th>
  
</tr>
</thead>
<tbody>
{matchingUserList.map(dep => 
    <tr key={dep.id}>
      <td className="table-text">{dep.id}</td>
      <td className="table-text">{dep.username}</td>
      <td className="table-text">{dep.first_name}</td>
      <td className="table-text">{dep.last_name}</td>
      <td className="table-text">{dep.email}</td>


      <td>
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
className="btn btn-primary m-2"
data-bs-toggle="modal"
data-bs-target="#exampleModalPassword"
onClick={()=>this.editClickPassword(dep)}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Edit Password
</button>

          </td>
    </tr>

)}
</tbody>
</table>
</div>


<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Username</span>
          <input
            type="text"
            className={`form-control ${usernameExists ? "is-invalid" : ""}`}
            value={username}
            onChange={this.changeUserName}
            onBlur={this.checkUserNameExists} // Check SAP code existence on blur (when user moves out of the field)
            style={{ fontSize: "12px" }}
            autoComplete="off"
          />
          {usernameExists && <div className="invalid-feedback" style={{ fontSize: "12px" }}>username already exists.</div>}
        </div>
         
         
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>First Name</span>
          <input type="text" className="form-control" value={first_name} onChange={this.changeFirstName} 
          style={{ fontSize: "12px" }}
          />
        </div>
        
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Last Name</span>
          <input type="text" className="form-control" value={last_name} onChange={this.changeLastName} 
          style={{ fontSize: "12px" }}
          autoComplete="off"
          />
        </div>
         
         
         
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Email</span>
          <input
            type="text"
            className={`form-control ${useremailExists ? "is-invalid" : ""}`}
            value={email}
            onChange={this.changeEmail}
            onBlur={this.checkUserEmailExists} // Check SAP code existence on blur (when user moves out of the field)
            style={{ fontSize: "12px" }}
            autoComplete="off"
          />
          {useremailExists && <div className="invalid-feedback" style={{ fontSize: "12px" }}>email already exists.</div>}
        </div>
        

        {id === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {id !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(id)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModalPassword" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitlePassword}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        
      <div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Password</span>
  <input
    type="password"
    className={`form-control ${passwordError ? "is-invalid" : ""}`}
    value={password}
    onChange={this.changePassword}
    onBlur={this.handlePasswordBlur} // Check password strength on blur
    style={{ fontSize: "12px" }}
    data-testid="password-field"
    minLength="8"
    autoComplete="new-password"
    placeholder="Password"
  />
  {passwordError && <div className="invalid-feedback" style={{ fontSize: "12px" }}>Password is not strong enough.Password (at least 8 characters, including uppercase, lowercase, numbers, and special characters)</div>}
</div>

<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Password</span>
  <input
    type="password"
    className={`form-control ${passwordsMatch ? "is-invalid" : ""}`}
    value={password2}
    onChange={this.changePassword2}
    onBlur={this.handlePassword2Blur}
    style={{ fontSize: "12px" }}
    data-testid="password-field2"
    minLength="8"
    autoComplete="new-password"
    placeholder="Verify Password"
  />
  {passwordsMatch && <div className="invalid-feedback" style={{ fontSize: "12px" }}>Passwords do not match</div>}
</div>


        {id !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClickPassword(id)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

</div>

</div>

 
  )
}
}

